import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import url from "../../config/url";
Vue.use(Vuex);
const state = {
    status: null,
    exhibitorCollection: null,
    exhibitorCollectionAll: null,
    exhibitorFilteredCollection: [],
    exhibitorForFilters:null,
    exhibitors: [],
    pages: 0,
    exhibitorPerPage: 30,
    selectedPage: 1,
    title: "",
    category: "",
    tags:"",
    description: "",
    description2: "",
    room: "",
    type:"",
    startDate: "",
    assets: "",
    hosted: "",
    heading: "",
    publishedSessionId: 0,
    slotsId: 0,
    user: [],
    slots: [],
    slotsUser: [],
    dayname: "",
    startDateFormatted: "",
    startTime: "",
    endTime: "",
    intialStartStatus: 1,
    productCategories: [],
    agendaFilters:[],
    session_categories:null,
    loader:true
};

const mutations = {
    agendaData(state, data) {
        //debugger
        
        state.status = "All Exhibitor Data";
        state.selectedPage = 1;
        state.exhibitorCollection = data;
        state.exhibitorCollectionAll = data;
        //filter by date
        state.exhibitorCollectionAll = state.exhibitorCollectionAll.filter(x => x.startDate == x.earliestDate)
        state.exhibitorFilteredCollection = data;
        state.pages = Math.ceil(
            state.exhibitorCollection.length / state.exhibitorPerPage
        );
        state.exhibitors = state.exhibitorCollectionAll.slice(
            0,
            state.exhibitorPerPage
        );
        state.exhibitors = state.exhibitorCollectionAll;
        state.loader = false;

    },
    agendaById(state, data) {
        //debugger
        state.title = data[0].title;
        state.category = data[0].category;
        state.tags = data[0].tags;
        state.description = data[0].description;
        state.room = data[0].room;
        state.startDate = data[0].startDate;
        state.publishedSessionId = data[0].publishedSessionId;
        state.slotsId = data[0].slotsId;
        state.user = data[0].user;
        state.slots = data[0].slots;
       // state.slotsUser = data[0].slots.slotUsers;
        state.dayname = data[0].dayname;
        state.startDateFormatted = data[0].startDateFormatted;
        state.startTime = data[0].startTime;
        state.endTime = data[0].endTime;        
        state.heading = data[0].title;
        state.hosted = data[0].hosted;
        state.assets = data[0].assets;
        state.type = data[0].type;
        state.session_categories = JSON.parse(data[0].sessionCategoriesJson);

        /*test
        // debugger
        state.status = "All Exhibitor Data";
        state.selectedPage = 1;
        state.exhibitorCollection = data;
        //state.exhibitorCollectionAll = data;
        //filter by date
        state.exhibitorCollectionAll = state.exhibitorCollectionAll.filter(x => x.startDate == x.earliestDate)
        state.exhibitorFilteredCollection = data;
        state.pages = Math.ceil(
            state.exhibitorCollection.length / state.exhibitorPerPage
        );
        state.exhibitors = state.exhibitorCollectionAll.slice(
            0,
            state.exhibitorPerPage
        );
*/

    },
    setFilters(state,data){
        state.agendaFilters = data
    },
    agendaForFilters(state,data){
        state.exhibitorForFilters = data;
    },
    agendaDataList(state, data) {
        // debugger
        state.selectedPage = 1;
        state.status = "Alphanumeric Exhibitors";
        state.exhibitorFilteredCollection = data;
        state.exhibitors = state.exhibitorFilteredCollection.slice(
            0,
            state.exhibitorPerPage
        );
        state.pages = Math.ceil(
            state.exhibitorFilteredCollection.length / state.exhibitorPerPage
        );
        state.exhibitors = state.exhibitorFilteredCollection;
    },










    /*not using */
    filteredExhibitor(state, data) {
        state.status = "Filtered Exhibitor data";
        state.exhibitorCollection = data;
        state.exhibitorFilteredCollection = data;
        state.pages = Math.ceil(
            state.exhibitorFilteredCollection.length / state.exhibitorPerPage
        );
        state.exhibitors = state.exhibitorFilteredCollection.slice(
            0,
            state.exhibitorPerPage
        );
        state.exhibitors = state.exhibitorFilteredCollection;
        state.selectedPage = 1;
    },
    PaginatedExhibitor(state, data) {
        state.status = "Paginated Exhibitors";
        state.exhibitors = data;
    },
    ActivePage(state, pageNumber) {
        state.selectedPage = pageNumber;
    }
};

const actions = {
    agendaInitialList: function ({ commit },type) {
        // debugger
        axios.get(url.initial_load_api(type))
            .then(response => {
                //console.log(response.data)
                commit("agendaData", response.data);
                commit("agendaForFilters", response.data);
            }).catch(err => {
                console.log(err.response);
            });
    },
    setFilteredagenda: function ({ commit },agendaList){
        commit("agendaData",agendaList)
    },
    agendaDetailsById: function ({ commit }, { publishedSessionId, slotId }) {
        //debugger
        axios
            .get(url.agenda_detail_api, { params: { PublishedSessionId: publishedSessionId ,slotId: slotId} })
            .then(response => {
                commit("agendaById", response.data);
            })
            .catch(error => {
                console.log(error);
            });
    },
    agendaFilterByCategoryAndDay: function ({ commit }, objCategoryAndDay) {
        //console.log(obj['alphabet']); 
        commit(
            "agendaDataList",
            state.exhibitorCollection.filter(
                exhibitor =>
                    exhibitor.category == objCategoryAndDay['categoryName'] && exhibitor.startDate == objCategoryAndDay['selectedDayValue']
            )
        );
    },
    agendaFilterByDay: function ({ commit }, selectedDay) {
        commit(
            "agendaDataList",
            state.exhibitorCollection.filter(
                exhibitor =>
                    exhibitor.startDate == selectedDay
            )
        );
    },




    getFilters: function ({ commit }) {
        // debugger
        axios.get(url.filers)
            .then(response => {
                commit("setFilters", response.data);
            }).catch(err => {
                console.log(err.response);
            });
    },





    /*not using */
    exhibitorPaginatedList: function ({ commit }, pageNum) {
        commit(
            "PaginatedExhibitor",
            state.exhibitorFilteredCollection.slice(
                (pageNum - 1) * state.exhibitorPerPage,
                pageNum * state.exhibitorPerPage
            )
        );
    },
    exhibitorNumericList: function ({ commit }) {
        commit(
            "AlphaNumericExhibitor",
            state.exhibitorCollection.filter(
                exhibitor => exhibitor.CompanyName[0] >= 0
            )
        );
    },
    exhibitorViewAllList: function ({ commit }) {
        commit(
            "AlphaNumericExhibitor",
            state.exhibitorCollection.filter(exhibitor => exhibitor)
        );
    },
    activePaging: function ({ commit }, pageNumber) {
        commit("ActivePage", pageNumber);
    }
};

export default {
    state,
    mutations,
    actions
};